function calcularDiferencaEmMeses(data1, data2) {
  const diff = (data2.getFullYear() - data1.getFullYear()) * 12 + data2.getMonth() - data1.getMonth();
  return Math.abs(diff);
}

export function calculaTempoDataCirurgia(dataCirurgia) {
  const [mes, ano] = dataCirurgia.split('/');
  const dataConvertida = new Date(ano, mes - 1, 1); // Mês - 1 porque os meses em JavaScript são baseados em zero

  const dataAtual = new Date();

  let tempoCirurgia = calcularDiferencaEmMeses(dataConvertida, dataAtual);
  let retorno = `${tempoCirurgia} meses`

  if (tempoCirurgia >= 12) {
    tempoCirurgia = Math.floor(tempoCirurgia / 12);
    retorno = `${tempoCirurgia} anos`
  }

  return retorno
};